module.exports = __webpack_public_path__ + "img/tcm-about-us-main.4c90f784.png";